// extracted by mini-css-extract-plugin
export default {"cls1":"XNmY6Nya_0DuJwssmiqi","cls2":"E6A3_hj2CTqFJYH9gG_X XNmY6Nya_0DuJwssmiqi"};